module.exports = __webpack_public_path__ + "static/img/mediaweek.89ae63c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mediaweek.png
// module id = uSaN
// module chunks = 14